export const EMPTY_DATA_SEARCH_REFERENCE_TEMPLATE_CONTRACT = {
    text_search: '',
    row: 12,
    status: null,
    contract_type_uuid: null,
    from_date: null,
    to_date: null,
    source_type: null,
    created_by: null
};
